import moment from "moment";
import _ from "lodash";
import { constants } from "./constants";
import * as XLSX from "xlsx";
import { styled } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { forwardRef } from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { AgGridReact } from "ag-grid-react";

export function formatQuantity(p: any) {
  if (isNumber(p.value)) {
    return formatNumber_q.format(p.value);
  }
}

export const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

function isNumber(char: any) {
  return !isNaN(parseInt(char));
}

export const is_number = (char: any) => {
  return !isNaN(parseInt(char));
};

export const myValueFormatter = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber.format(p.value);
  }
};
export function formatRatio(p: any) {
  if (isNumber(p.value)) {
    return formatNumberRatio.format(p.value)
  }
}
export const formatNumberRatio = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 4
})
export const DollarFormatWithoutDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
})


export const DollarFormatter = (p: any) => (isNumber(p.value) ? formatNumber.format(p.value) : '')

export const valueFormatterUSDWithoutDecimals = (p: any) =>
  isNumber(p.value) ? DollarFormatWithoutDecimals.format(p.value) : ''

export const valueFormUSDWithoutDecimalsForNonGrid = (p: any) =>
  isNumber(p) ? DollarFormatWithoutDecimals.format(p) : ''
export const gridCentsPerShareFormatter = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 4,
      minimumFractionDigits: 4,
    }).format(p.value);
  }
};
export const getDarkRowStyle = (params: any) => {
  if (params.node.rowIndex % 2 === 0 && params.node.rowPinned !== 'bottom') {
    return {
      borderTop: 'none',
      borderRight: '0.5px solid #E1E1E1',
      backgroundColor: '#131314'
    }
  } else if (params?.data?.isTotalLabel || params.node.rowPinned === 'bottom') {
    return {
      borderTop: 'none',
      borderRight: '0.5px solid #E1E1E1',
      backgroundColor: '#272938'
    }
  }

  return {
    borderTop: 'none',
    borderRight: '0.5px solid #E1E1E1',
    backgroundColor: '#131314'
  }
}

export const Grid = styled(AgGridReact)<any>(({ theme }) => ({
  '& .ag-header-row': {
    color: theme.palette.mode === 'dark' ? '#E9E9E9' : theme.palette.primary.main
  }
}))

export const markFormatter = (p: any) => {
  if (p?.value && !isNaN(p?.value) && _.isString(p.value)) {
    return parseInt(p.value)
  } else if (_.isNumber(p?.value)) {
    return p?.value
  }

  return ''
}

export function rowValueFormatter(p: any) {
  let is_n = isNumber(p.value);
  if (is_n) {
    return formatNumber.format(p.value);
  }
  return p.value;
}

export function dateFormat(row: any) {
  if (row?.value) {
    var date = moment(row?.value);
    try {
      return date.isValid() ? date.format("YYYY-MM-DD") : row?.value;
    } catch (e) {}
  }

  return row?.value;
}

export function dateFormatNonGrid(value: any) {
  if (value) {
    var date = moment(value);
    try {
      return date.isValid() ? date.format("YYYY-MM-DD") : value;
    } catch (e) {}
  }

  return value;
}

export const validateMark = (markValue: any) => {
  let mark = parseInt(markValue);
  if (mark && mark > 95 && mark < 106) {
    return true;
  }
  return false;
};

export const myValueFormatter_quantity = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumber_q.format(p.value);
  }
};

export function getTimeStamp(value: any) {
  if (value && moment(value).isValid()) {
    return moment(value).format(constants.DateTimeFormat);
  }
  return "";
}

export function cptyIdOrTickerFormatter(row: any) {
  if (row?.value) {
    try {
      return row?.value.toUpperCase();
    } catch (e) {}
  }

  return row?.value;
}

export const formatNumber = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

export const formatNumberNoFrac = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const myValueFormatterNoFrac = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return formatNumberNoFrac.format(p.value);
  }
};

export const getRowStyle: any = (params: any) => {
  if (params.node.data?.clicked && params.node.rowPinned !== "bottom") {
    params.node.suppressRowHoverHighlight = true;
    return { background: "#bbdffc" };
  } else if (
    params.node.rowIndex % 2 === 0 &&
    params.node.rowPinned !== "bottom"
  ) {
    return { background: "#F8F8F8" };
  }
  if (params.node.rowPinned === "bottom") {
    return {
      backgroundColor: "#fff !importnat",
      color: "#164691",
      fontWeight: "700",
      fontSize: "0.75rem",
      fontStyle: "normal",
      borderBottom: "none",
      border: "none",
    };
  } else {
    return { backgroundColor: "#fff" };
  }
};

export const workBookGridStyle: any = (params: any) => {
  if (params.node.rowPinned === "bottom") {
    return {
      backgroundColor: "#fff !importnat",
      color: "#164691",
      fontWeight: "700",
      fontSize: "0.75rem",
      fontStyle: "normal",
      borderBottom: "none",
      border: "none",
    };
  } else {
    return { backgroundColor: "#fff" };
  }
};

export const getRowStyleRecallBuyIn: any = (params: any) => {
  if (
    params?.node?.data?.recall === "Y" &&
    params?.node?.data?.is_buyin === "Y"
  ) {
    return { background: "#FFEED4" };
  } else if (
    params?.node?.data?.recall === "Y" &&
    params?.node?.data?.is_buyin === "N"
  ) {
    return { background: "rgb(255 222 225 / 60%)" };
  } else if (
    params?.node?.data?.recall === "N" &&
    params?.node?.data?.is_buyin === "Y"
  ) {
    return { background: "#FFEED4" };
  } else if (
    params.node.rowIndex % 2 === 0 &&
    params.node.rowPinned !== "bottom"
  ) {
    return { background: "#F8F8F8" };
  }
  if (params.node.rowPinned === "bottom") {
    return {
      backgroundColor: "#fff !important",
      color: "#164691",
      fontWeight: "700",
      fontSize: "0.75rem",
      fontStyle: "normal",
      borderBottom: "none",
      border: "none",
    };
  } else {
    return { backgroundColor: "#fff" };
  }
};

export const getRowStyleMuiAgGrid: any = (params: any) => {
  if (
    params?.node?.data?.is_recall === "Y" &&
    params?.node?.data?.is_buyin === "Y"
  ) {
    return { background: "#FFEED4" };
  } else if (
    params?.node?.data?.is_recall === "Y" &&
    params?.node?.data?.is_buyin === "N"
  ) {
    return { background: "rgb(255 222 225 / 60%)" };
  } else if (
    params?.node?.data?.is_recall === "N" &&
    params?.node?.data?.is_buyin === "Y"
  ) {
    return { background: "#FFEED4" };
  }
  if (
    params?.node?.rowIndex % 2 === 0 &&
    params?.node?.rowPinned !== "bottom"
  ) {
    return { background: "#F3F5F8" };
  }
  if (params?.node?.rowPinned === "bottom") {
    return {
      backgroundColor: "#fff !importnat",
      color: "#164691",
      fontWeight: "700",
      fontSize: "0.75rem",
      fontStyle: "normal",
      borderBottom: "none",
      border: "none",
    };
  } else {
    return { backgroundColor: "#fff" };
  }
};

export const debounceGlobalSearch = _.debounce(function (
  search: string,
  setFunc: any
) {
  setFunc(search);
},
800);

export const mapRowId = (rows: any[]) => {
  if (_.isEmpty(rows)) return rows;
  else
    return rows.map((row: any, index: any) => {
      return {
        ...row,
        id: index.toString(),
      };
    });
};

export const onKeyDown = (e: any) => {
  if (e.key === "Tab") {
    window.setTimeout(function () {
      document.getElementById("submit")?.focus();
    }, 0);
  }
};

export const hasAccess = (permittedRoles: string[]) => {
  let currentAccountString = window.localStorage.getItem(
    "currentActiveAccount"
  );
  let account = currentAccountString && JSON.parse(currentAccountString);
  let permissions = account?.permissions;
  const loggedInUserRoles = permissions;
  if (Array.isArray(loggedInUserRoles) && loggedInUserRoles?.length > 0) {
    return permittedRoles?.some((role: any) =>
      loggedInUserRoles?.includes(role)
    );
  }
};

export const makeRequest = (
  method: string,
  url: string,
  success: (data: any) => void,
  error: (error: any) => void
) => {
  var httpRequest = new XMLHttpRequest();
  httpRequest.open("GET", url, true);
  httpRequest.responseType = "arraybuffer";

  httpRequest.open(method, url);
  httpRequest.onload = function () {
    success(httpRequest.response);
  };
  httpRequest.onerror = function () {
    error(httpRequest.response);
  };
  httpRequest.send();
};

export const convertDataToWorkbook = (dataRows: any) => {
  var data = new Uint8Array(dataRows);
  var arr = [];
  for (var i = 0; i !== data.length; ++i) {
    arr[i] = String.fromCharCode(data[i]);
  }
  var bstr = arr.join("");
  return XLSX.read(bstr, { type: "binary" });
};

export const formatOptionLabel = ({ label, value }: any) => {
  const splitValue = value.split("/");

  return (
    <div style={{ display: "flex" }}>
      <div>{splitValue[0]}</div>
      <div style={{ color: "#000", marginLeft: "10px" }}>{splitValue[1]}</div>
      <div style={{ color: "#000", marginLeft: "10px" }}>{label}</div>
    </div>
  );
};

export const customFilterTicker = (option: any, searchText: any) => {
  if (
    option.data.cusip.toLowerCase().startsWith(searchText.toLowerCase()) ||
    option.data.ticker.toLowerCase().startsWith(searchText.toLowerCase())
  ) {
    return true;
  } else {
    return false;
  }
};

export const getDivHeight = (id: string, extraHeight = 0) => {
  const offsetHeight = document?.getElementById(id)?.offsetHeight;
  const divHeight = _.isUndefined(offsetHeight)
    ? extraHeight
    : offsetHeight + extraHeight;

  return "calc(100% - " + divHeight + "px)";
};

export const convertToCommas = (value: any) => {
  const is_n = is_number(value);
  if (is_n) {
    return formatNumber_q.format(value);
  }
};

export const hexToRGBA = (hexCode: string, opacity: number) => {
  let hex = hexCode.replace("#", "");

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const rateFormatter = (p: any) => {
  let is_n = is_number(p.value);
  if (is_n) {
    return parseFloat(p?.value)?.toFixed(4);
  }
};

export const DollarFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

export const DollarFormatterNonGridValue = (p: any) =>
  isNumber(p) ? DollarFormat.format(p) : "";

export const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .MuiDataGrid-columnHeader": {
    backgroundColor:
      theme.palette.mode === "dark" ? "rgb(74, 80, 114)" : "#c2cfe094",
    color:
      theme.palette.mode === "dark" ? "#E9E9E9" : theme.palette.primary.main,
  },
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.mode === "dark" ? "#272938" : "#F3F5F8",
  },
}));

export function getTimeStampDBDateFormat(value: any) {
  if (value && moment(value).isValid()) {
    return moment(value).format(constants.DateTimeDBFormat);
  }

  return "";
}

export const dbDateFormatterForGrid = (p: any) => {
  if (p.value && moment(p.value).isValid()) {
    return moment(p.value).format(constants.DateTimeDBFormat);
  }

  return "";
};

export const dateFormatterForGrid = (p: any) => {
  if (p.value && moment(p.value).isValid()) {
    return moment(p.value).format(constants.DateTimeFormat);
  }

  return "";
};

export const dbTimeFormatterForGrid = (p: any) => {
  if (p.value && moment(p.value).isValid()) {
    return moment(p.value).format(constants.TimeDBFormat);
  }

  return "";
};

export const onlyDateFormatterForGrid = (p: any) => {
  if (p.value && moment(p.value).isValid()) {
    return moment(p.value).format(constants.DateDBFormat);
  }

  return "";
};

export const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export function calculateContractPriceFromValues(
  tickerPrice: any,
  markField: any,
  counterPartyField: any
) {
  const price: any = tickerPrice? parseFloat(tickerPrice): null;
  const mark: any = !_.isNull(markField) && !isNaN(markField)? parseFloat(markField): 100;
  let contractPrice: any = price;

  if (price && mark) {
    const rawContractPrice = (price * mark) / 100;
    // round up
    if (counterPartyField.hse_ind === "U") {
      if (+counterPartyField.hse_rnd === 0) {
        return Math.ceil(rawContractPrice);
      } else {
        contractPrice =
          Math.ceil((rawContractPrice / +counterPartyField.hse_rnd)) * +counterPartyField.hse_rnd
          

        return contractPrice?.toFixed(2);
      }
    }
    // round down
    else if (counterPartyField.hse_ind === "D") {
      if (+counterPartyField.hse_rnd === 0) {
        return Math.floor(rawContractPrice);
      } else {
        contractPrice =
          Math.floor((rawContractPrice / +counterPartyField.hse_rnd)) * +counterPartyField.hse_rnd;
          

        return contractPrice?.toFixed(2);
      }
    } else {
      
      return rawContractPrice?.toFixed(2);
    }
  }
  return contractPrice?.toFixed(2);
}

export const isValidGuid = (value?: string): boolean => {
  if (!value) return false

  const guidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

  return guidRegex.test(value)
}
